import { Component, Output, ViewChild } from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';
import { TradingSystemSummaryComponent } from '../trading-system-summary/trading-system-summary.component';
import { TradingSystemGraficoWeeklyComponent } from '../trading-system-grafico-weekly/trading-system-grafico-weekly.component';
import * as Highcharts from 'highcharts';
import { TradingSystemSummary } from 'src/app/models/trading-system-summary';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { ModalGraphComponent } from '../modal-graph/modal-graph.component';
import { EventEmitter } from '@angular/core';

declare global {
  interface Window {
    aprimodal: any;
  }
}

@Component({
  selector: 'app-trading-system-report',
  standalone: true,
  imports: [HighchartsChartModule, TradingSystemSummaryComponent,
    TradingSystemGraficoWeeklyComponent],
  templateUrl: './trading-system-report.component.html',
  styleUrl: './trading-system-report.component.scss'
})
export class TradingSystemReportComponent {
  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  ts!: TradingSystemSummary
  @ViewChild('chartWeek') chartWeek!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartBuy') chartWeekBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartSell') chartWeekSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonth') chartMonth!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlyBuy') chartMonthlyBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartMonthlySell') chartMonthSell!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartOrario') chartOrario!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartOrarioBuy') chartOrarioBuy!: TradingSystemGraficoWeeklyComponent
  @ViewChild('chartOrarioSell') chartOrarioSell!: TradingSystemGraficoWeeklyComponent
  modalRef: MdbModalRef<ModalGraphComponent> | null = null;

  titolo: string = 'Trading System Report'
  selezionato: string = ''
  timeframe: string = 'm15'
  datoRiferimento: any = ''

  constructor(private modalService: MdbModalService) { }

  ngOnInit(): void {
    window.aprimodal = this.openModal;
  }

  openModal(tableData: any, graphData: any, that: any, title: string, id: any) {
    this.datoRiferimento = tableData
    
    that.modalRef = that.modalService.open(ModalGraphComponent, {
      data: {
        tableData: [tableData],
        graphData: graphData,
        title: title,
        params: { mkt: that.selezionato, id: id, timeframe: that.timeframe }
      },
      modalClass: 'modal-dialog-centered modal-xl'
    })
  }

  caricaDati(mercato: any, timeframe: string, dati: any) {
    this.timeframe = timeframe
    this.selezionato = mercato.market
    this.chartWeek.caricaDati(dati)
    this.chartWeekBuy.caricaDati(dati.filter((el: any) => el.verso == 'buy'))
    this.chartWeekSell.caricaDati(dati.filter((el: any) => el.verso == 'sell'))
    this.chartMonth.caricaDatiMese(dati)
    this.chartMonthlyBuy.caricaDatiMese(dati.filter((el: any) => el.verso == 'buy'))
    this.chartMonthSell.caricaDatiMese(dati.filter((el: any) => el.verso == 'sell'))
    this.chartOrario.caricaDatiOrario(dati)
    this.chartOrarioBuy.caricaDatiOrario(dati.filter((el: any) => el.verso == 'buy'))
    this.chartOrarioSell.caricaDatiOrario(dati.filter((el: any) => el.verso == 'sell'))
    this.ts = new TradingSystemSummary().popolaDati(mercato.market, mercato.pip, dati)
    this.ts.spread = mercato.spread
    this.aggiornaGrafico(dati)
  }

  aggiornaGrafico(data: any) {
    let prog = 0
    data = data.map((el: any) => {
      prog += parseFloat(el.profit)
      el.prog = prog
      return el
    })
    let s1 = data.map((el: any) => [el.ora, el.prog])
    let s2 = data.map((el: any) => [el.ora, parseFloat(el.close)])
    var that = this
    this.chartOptions = {
      title: {
        text: 'Backtest '+ this.selezionato.toUpperCase()+' '+ this.timeframe.toUpperCase()
      },
      chart: {
        zooming: {
          type: 'x'
        }
      },
      series: [{
        name: 'Progressivo',
        data: s1,
        type: 'line',
        color: 'lime',
      }, {
        name: this.selezionato,
        data: s2,
        type: 'line',
        dashStyle: 'ShortDot',
        yAxis: 1,
      }],
      yAxis: [
        {
          title: {
            text: 'Progressivo'
          }
        },
        {
          title: {
            text: 'Cambio'
          },
          opposite: true
        }
      ],
      plotOptions: {
        series: {
          events: {
            click: function (event) {
              window.aprimodal(data[event.point.x], s2, that, 'Operazione numero ' + event.point.x, event.point.x)
            }
          },
          turboThreshold: 9000
        }
      },
    }
    this.updateFlag = true
  }

}
